import { useEffect, useState } from "react";
import { getFreeChallengesIb } from "../../../../../services/challenge-orders/challenge-orders.services";
import { Paginated } from "modules/dashboard/components/paginated.component";
import { usePagination } from "../../../hooks/usePagination";
import { rowTablePipe } from "../../../pipes/common";
import { DefaultTable } from "../../../components/table.component";
import { vars } from "services/constants";
import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";

const cols = [
  {
    label: "ID",
    property: "id",
    responsive: {
      state: true,
    },
  },
  {
    label: "Email",
    property: "email",
    responsive: {
      state: true,
    },
  },
  {
    label: "Inicio",
    property: "startDate",
    responsive: {
      state: true,
    },
  },
  {
    label: "Challenge",
    property: "challenge",
    responsive: {
      state: true,
    },
  },
  {
    label: "Balance actual",
    property: "mt5AccountBalance",
    responsive: {
      state: true,
    },
  },
  {
    label: "Estado",
    property: "grade",
    responsive: {
      state: true,
    },
  },
  {
    label: "Beneficio",
    property: "freeBenefitStatus",
    responsive: {
      state: true,
    },
  },
    {
    label: "Expira en",
    property: "endDate",
    responsive: {
      state: true,
    },
  },
];

export function ReferredFreeAccountsTable() {
  const [referredAcc, setReferredAcc] = useState([]);
  const { pagination, itemsCounter, setItemsCount, changePage, changeSize } = usePagination();

  const fetchReferredAcc = async () => {
    const result = await getFreeChallengesIb({ pagination });

    const rowData = rowTablePipe(result.data.items);

    setItemsCount(result.data.itemsCounter || 0);
    setReferredAcc(rowData);
  };

  useEffect(() => {
    fetchReferredAcc();
  }, [pagination]);

  return (
    <>
     <VuiBox sx={{ paddingLeft: "30px", paddingTop: "20px" }}>
          <VuiTypography
            sx={{
              fontSize: "16px",
              fontWeight: "700",
              lineHeight: "32px",
              color: "#FFFFFF",
            }}
          >
            {vars.freeChallenge.vars.name}
          </VuiTypography>
        </VuiBox>
      <DefaultTable rows={referredAcc} cols={cols} fetchReferred={[]} />
      <Paginated
        itemsCounter={itemsCounter}
        pageSize={pagination.paging_size}
        currentPage={pagination.paging_index}
        changePage={changePage}
        changeSize={changeSize}
      />
    </>
  );
}
